<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ 'order_lists_download' | translate }}</h3>
      </div>
      <div class="box-body">
        <p>{{ 'download_orders_text' | translate }}</p>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <div class="input-group">
              <div class="input-group-addon">
                {{ 'period' | translate }}
              </div>
              <date-range-picker
                id="ordertime"
                :startDate="startRange"
                @pepe="onDateRangeChanged"
              >
              </date-range-picker>
              <span class="input-group-btn">
                <button
                  class="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Start generating an order list in your specified date range"
                  v-if="this.generatingDownload==false && this.readyForDownload==false"
                  @click="startGenerate()"
                >
                  <i class="fa fa-play mr-5"></i> {{ 'generate_list' | translate }}
                </button>
                <button
                  class="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="generating download ... "
                  v-if="this.generatingDownload==true && this.readyForDownload==false"
                  disabled="disabled"
                >
                   <i class="fa fa-spinner fa-spin"></i> {{ 'generating_list' | translate }}
                </button>
                <button
                  class="btn btn-success"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Download an order list in your specified date range"
                  v-if="this.generatingDownload==false && this.readyForDownload==true"
                  @click="downloadOrderList()"
                >
                  <i class="fa fa-download mr-5"></i> {{ 'ready_to_download' | translate }}
                </button>
              </span>
            </div>
          </div>
        </div>
        <p/>
        <div class="row " v-if="this.generatingDownload==true && this.readyForDownload==false">
          <div class="col-md-4 col-sm-6" style="color:red">
            <strong><i class="fa fa-warning"></i> {{ 'do_not_reload_warning'|translate }}</strong>
          </div>
        </div>
        <div class="row " v-if="this.has_errors">
          <div class="col-md-4 col-sm-6" style="color:red">
            <strong><i class="fa fa-warning"></i> {{ this.error }}</strong>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import DateRangePicker from '../../tools/DateRangePicker.vue'

export default {
  name: 'OrderList',
  data () {
    return {
      startRange: moment().subtract(1, 'month'),
      endRange: moment(),
      generatingDownload: false,
      readyForDownload: false,
      fileName: '',
      has_errors: false,
      error: ''
    }
  },
  components: {
    dateRangePicker: DateRangePicker
  },
  methods: {
    onDateRangeChanged (picker) {
      this.dateRange = `${picker.startDate} - ${picker.endDate}`
      this.startRange = picker.startDate
      this.endRange = picker.endDate
      this.generatingDownload = false
      this.readyForDownload = false
      this.has_errors = false
      this.error = ""
    },
    downloadOrderList () {
      API.get(`download/orderList/downloadFile?fileName=${this.fileName}`)
        .then(response => {
          let encodedUri = response.data
          let link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'orders_' + this.startRange + '_' + this.endRange + '.csv')
          document.body.appendChild(link)
          link.click()
          this.generatingDownload = false
        }).catch(error => {
        this.error = error
        this.has_errors = true
        this.generatingDownload = false
      })
    },
    startGenerate () {
      let start = this.startRange.format('YYYY-MM-DD')
      let end = this.endRange.format('YYYY-MM-DD')
      this.generatingDownload = true
      API.post(`download/orderList/startGenerate`, {'start': start, 'end': end})
        .then(response => {
          this.has_errors = false
          this.error = ''
          this.fileName = response.data.fileName
          this.checkForFinishedList()
        }).catch(error => {
        this.error = error
        this.has_errors = true
        this.generatingDownload = false
      })
    },
    checkForFinishedList () {
      var counter = 0
      let interval = setInterval(() => {
        if (counter == 50) {
          clearInterval(interval)
          this.generatingDownload = false
          this.readyForDownload = false
          this.error = 'time out'
          this.has_errors = true
        }
        API.get(`download/orderList/checkFile?fileName=${this.fileName}`)
          .then(response => {
            if (response.data.readyToDownload === true) {
              this.readyForDownload = true
              this.generatingDownload = false
              clearInterval(interval)
            }
          }).catch(error => {
          this.error = error
          this.has_errors = true
          this.generatingDownload = false
          clearInterval(interval)
        })
        counter++
      }, 2000)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
select option.normal {
  margin: 40px;
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, .4)
}

select option.normal {
  background: #202227
}
</style>



// WEBPACK FOOTER //
// src/components/views/Downloads/OrderList.vue